"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
var useAppBridgeState_1 = require("../useAppBridgeState");
function useLocale() {
    return useAppBridgeState_1.useAppBridgeState('staffMember.locale');
}
exports.useLocale = useLocale;
